import { combineReducers, createStore } from "redux";
import LoaderReducer from "./reducers/loadingReducer";

const RootReducer = combineReducers({
  isLoading: LoaderReducer,
});

export const store = createStore(RootReducer);
